import ActionsCell from "./ActionsCell";

export const getColumns = () => [
  {
    field: "full_name",
    headerName: "Full Name",
    width: 220,
  },
  {
    field: "total_delivered_order",
    headerName: "Total Delivered Orders",
    width: 250,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_days",
    headerName: "Total Days",
    width: 250,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_hours",
    headerName: "Total Time",
    width: 250,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  // {
  //   field: "current_stop_progress",
  //   headerName: "Stop Progress",
  //   width: 130,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "current_order_delivery_progress",
  //   headerName: "Order Delivery Progress",
  //   width: 200,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "current_driver_order_load_bay",
  //   headerName: "Order Load Bay",
  //   width: 160,
  //   sortable: false,
  // },
  // {
  //   field: "current_driver_order_load_mode",
  //   headerName: "Shift",
  //   width: 180,
  //   sortable: false,
  // },
  {
    field: "action",
    headerName: "Actions",
    width: 450,
    sortable: false,
    renderCell: (params) => <ActionsCell params={params} />,
  },
];
